import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAASUlEQVR42q3OsQ3AIAxEUULCAskOaWlBgOjYfyS+0RUMgKVXWD6d7NypufDg3tju7RgQMZDRUeS1wIcqCU2hX02rJqhy5898PwGRHAMQ/eU8rgAAAABJRU5ErkJggg=="};
